var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400.000000pt",
    height: "400.000000pt",
    viewBox: "0 0 400.000000 400.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1493 2002 c-304 -548 -551 -997 -550 -998 1 -2 348 201 771 451 423 250 772 452 776 450 4 -2 95 -162 201 -355 l194 -350 84 0 c62 0 82 3 78 12 -2 7 -100 184 -216 393 -195 351 -210 381 -194 393 10 8 110 68 223 135 l205 122 3 84 c2 65 0 82 -10 78 -7 -2 -125 -71 -262 -151 -137 -81 -252 -143 -255 -138 -3 6 -114 204 -246 441 -132 237 -242 431 -245 430 -3 0 -253 -448 -557 -997z m922 41 c-6 -8 -1070 -631 -1072 -629 -3 3 366 673 654 1189 l55 99 183 -329 c100 -180 181 -329 180 -330z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlLogo);
export default __webpack_public_path__ + "static/media/atl_logo.2ca674cf4bde1d21211130fc0a86e783.svg";
export { ForwardRef as ReactComponent };